import React, { useState, useEffect } from "react";
import configs from "../../../../constants/configs";
import ChiTietHopDongApi from "../../../../service/chiTietHopDongApi";

export const TaiSanThanhLy = ({ hopdong, choVayId }) => {
  useEffect(() => {
    DanhSachTaiSanCamCo();
    return () => {
      UpdateDataTaiSanCamCo({}); // This worked for me ** fix: To fix, cancel all subscriptions and asynchronous tasks in a use Effect cleanup function
    };
  }, []);

  const dataInit = {
    List: [],
    TotalRows: 0,
  };
  const [dataTaiSanCamCo, UpdateDataTaiSanCamCo] = useState(dataInit);
  const DanhSachTaiSanCamCo = () => {
    ChiTietHopDongApi.getListTaiSanCamCo1(choVayId).then((response) => {
      UpdateDataTaiSanCamCo({
        ...dataTaiSanCamCo,
        List: response.data.List,
        TotalRows: response.data.TotalRows,
      });
    });
  };

  const returnImageLink = (strImage) => {
    if (strImage === "" || strImage == null) {
      return configs.imageServer + "/images/no_image.png";
    } else {
      if (strImage && strImage.indexOf("http") > -1) {
        return strImage;
      } else {
        if (strImage.substring(0, 7) == "Morman/") {
          return configs.apiViewUpload + strImage;
        } else {
          return configs.imageServer + strImage;
        }
      }
    }
  };

  const listItem = () => {
    return (
      dataTaiSanCamCo.List != null &&
      dataTaiSanCamCo.List.map((item, index) => {
        let lstAnh = [];
        let NoteTaiSan = "";
        if (hopdong.Type !== 3) {
          lstAnh = item.Img ? item.Img.split(",") : [];
          NoteTaiSan = item.Note;
        }

        return (
          <>
            {hopdong.Type !== 3 && (
              <div class="Left808x200">
                <div id="ctl00_ContentPlaceHolder_ViewDetailChoVay_UpdatePanel12">
                  <div class="form-body form-bordered-1">
                    <div class="form-group row last-1">
                      <label class="col-md-3 label-control">Tên tín chấp</label>
                      <div class="col-md-9">{NoteTaiSan}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {hopdong.Type !== 3 && (
              <div className="main-slider slider-ts">
                {lstAnh.map((item) => (
                  <a href={item} data-fancybox="images">
                    <img src={returnImageLink(item)} alt="" />
                  </a>
                ))}
              </div>
            )}

            {hopdong.Type === 3 && (
              <tr className="active">
                <th scope="row">{index + 1}</th>
                <td className="text-left">{item.Code}</td>
                <td>{item.Note}</td>
                <td className="text-right">{item.PhiKho}</td>
              </tr>
            )}
          </>
        );
      })
    );
  };

  return (
    <>
      {hopdong.Type !== 3 && (
        <div className="table-responsive table-2">{listItem()}</div>
      )}
      {hopdong.Type === 3 && (
        <div className="table-responsive table-2">
          <table className="table table-bordered mb-0">
            <thead>
              <tr className="header-v2">
                <th>STT</th>
                <th className="text-left">Mã tài sản</th>
                <th>Ghi chú</th>
                <th className="text-right">Phí kho</th>
              </tr>
            </thead>
            <tbody>{listItem()}</tbody>
          </table>
        </div>
      )}
    </>
  );
};
